import { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SIDE_PANEL_DURATION_VALUE } from '#/shared/constants';
import { setSidePanelIsMinimized } from '#/user/slice';

const useSidePanelToggle = () => {
  const { sidePanelIsMinimized } = useSelector(s => s.user);
  const [readyToRemoveFromDom, setReadyToRemoveFomDom] = useState(false);
  const dispatch = useDispatch();

  const toggleSidePanelMinMax = useCallback(() => {
    dispatch(setSidePanelIsMinimized(!sidePanelIsMinimized));
  }, [dispatch, sidePanelIsMinimized]);

  const setSidePanelMaximized = useCallback(() => {
    dispatch(setSidePanelIsMinimized(false));
  }, [dispatch]);

  useEffect(() => {
    const removeFromDomTimeout = setTimeout(() => {
      if (sidePanelIsMinimized) {
        setReadyToRemoveFomDom(true);
      }
    }, SIDE_PANEL_DURATION_VALUE);
    if (!sidePanelIsMinimized) {
      setReadyToRemoveFomDom(false);
    }
    return () => {
      clearTimeout(removeFromDomTimeout);
    };
  }, [sidePanelIsMinimized]);

  return {
    sidePanelIsMinimized,
    toggleSidePanelMinMax,
    setSidePanelMaximized,
    readyToRemoveFromDom,
  };
};

export default useSidePanelToggle;
